export default "__VITE_ASSET__CGOo4yXh__"